export default function getInputs(id, finalUser) {
  const inputs = []; 
 function getBuenosAiresDateISO() {
  const now = new Date();

  // Ajustar la fecha al huso horario de Buenos Aires (-3 horas)
  const offsetMs = -3 * 60 * 60 * 1000; // -3 horas en milisegundos
  const bsAsDate = new Date(now.getTime() + offsetMs);

  // Obtener la fecha en formato YYYY-MM-DD
  return bsAsDate.toISOString().slice(0, 10);
}

const currentDate = getBuenosAiresDateISO();
  if (id) {
    inputs.push({
      id: 2,
      label: "Codigo",
      name: "aju_id",
      type: "int",
      readOnly: true,
      disable: true,
      externalId: id,
    });
  }

  inputs.push({
    id: 1,
    label: "Fecha de creacion",
    name: "createdAt",
    type: "date",
    readOnly: true,
    disable: true,
    defaultValue: currentDate,
  });
  
   inputs.push({
    id: 5,
    label: "Deposito",
    name: "aju_depo_id",
    type: "integer",
  });

  inputs.push({
    id: 3,
    label: "Nombre del Vendedor",
    name: "sel_fullname",
    type: "text",
    readOnly: true,
    disable: true,
    defaultValue: finalUser
      ? finalUser.sel_lastname + ", " + finalUser.sel_firstname
      : "Nombre No Disponible",
  });


  if (id) {
    inputs.push({
      id: 4,
      label: "Total De Articulos",
      name: "aju_total_art",
      type: "number",
      disable: true,
      readOnly: true,
    });
  }

  return inputs;
}
